/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProjectCodeAccessDTO = {
    Default: 'default',
    Restricted: 'restricted'
} as const;
export type ProjectCodeAccessDTO = typeof ProjectCodeAccessDTO[keyof typeof ProjectCodeAccessDTO];


export function instanceOfProjectCodeAccessDTO(value: any): boolean {
    for (const key in ProjectCodeAccessDTO) {
        if (Object.prototype.hasOwnProperty.call(ProjectCodeAccessDTO, key)) {
            if (ProjectCodeAccessDTO[key as keyof typeof ProjectCodeAccessDTO] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProjectCodeAccessDTOFromJSON(json: any): ProjectCodeAccessDTO {
    return ProjectCodeAccessDTOFromJSONTyped(json, false);
}

export function ProjectCodeAccessDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectCodeAccessDTO {
    return json as ProjectCodeAccessDTO;
}

export function ProjectCodeAccessDTOToJSON(value?: ProjectCodeAccessDTO | null): any {
    return value as any;
}

